const getAuthHeaders = () => {
  if (localStorage.getItem('customPanelAccessToken')) {
    return {
      'x-api-key': 'yoddha-service',
      Authorization: JSON.parse(localStorage.getItem('ims-token') || ''),
    };
  }
};

export { getAuthHeaders };
